/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useState, useContext, useRef } from 'react'
import {
  UnitSelectionContext,
  DatePickerContext,
  SpinContext,
  ErrorContext,
} from 'context'
import { UnitSelection, getApiTargetInfo, ExportComponent } from 'core'
import { DatePicker, Button, Input, Empty, message, Checkbox } from 'antd'
import { getValidationMonthly } from 'api/pgads.js'
import { cellRender } from './TabValidationScreen'
import { connect } from 'react-redux'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import { strCol, intCol, dateCol } from '@integec/grid-tools/lib/cols'
import { rowHeaderRender, exportDataComponent } from 'core/utils'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'

const headers = [
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
  }),
  utilityHeader,
  unitHeader,
  strCol({
    ident: 'shortName',
    display: 'Short Name',
    width: 150,
  }),
  dateCol({
    ident: 'errorDate',
    display: 'Error Date',
  }),
  intCol({
    ident: 'errorCode',
    display: 'Error Code',
  }),
  strCol({
    ident: 'errorMsg',
    display: 'Error Message',
    width: 850,
    // height:80,
    alignment: 'left',
  }),
  /* intCol({
    ident: 'severity',
    display: 'Severity',
  }),
  
  strCol({
    ident: 'deleted',
    display: 'Deleted',
  }),
  */
  modifierCol,
  modifiedDateCol,
]

const ValidationMonthly = ({ apiTargetInfo, utilityNameMap, unitNameMap }) => {
  //  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)
  // const [err, setError] = useState(null)
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  // const onShowError = e => setShowErrorOnly(e.target.checked)
  const [showErrorOnly, setShowErrorOnly] = useState(false)
  const [onlyError, setOnlyError] = useState([])
  const retrieveTask = _ => {
    if (selectedUnits.length <= 0) {
      message.warning('Please,Select Units')
      setVisibleUnitSelection(false)
      return
    }
    // setVisibleUnitSelection(false)
    setSpinning(true)
    getValidationMonthly(apiTargetInfo)(
      selectedDate.format('YYYY'),
      selectedDate.format('MM'),
      selectedUnits[0].utility,
      selectedUnits.map(u => u.utility + u.unit),
      showErrorOnly ? '1' : '0'
    ).fork(setError, data => {
      setSpinning(false)
      setData(data)
      setOnlyError(data.filter(u => u.severity === '1'))
    })
  }
  const title = 'Validation Monthly'
  const headerWithFormatter = headers.map(header =>
    header.ident === 'utility'
      ? {
          ...header,
          ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) => utilityNameMap[value] || value,
        }
      : header.ident === 'unit'
      ? {
          ...header,
          ...toSelectionColProps(unitNameMap),
          dataFormatter: ({ value }) => unitNameMap[value] || value,
        }
      : header
  )

  const GridRef = useRef()

  return (
    <div
      style={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <UnitSelection setData={() => setData([])} />
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
          }}
        >
          {title}
        </Title>
        <DatePicker.MonthPicker
          allowClear={false}
          format="MMMM-YYYY"
          value={selectedDate}
          onChange={d => {
            setSelectedDate(d)
          }}
        />
        <Button
          loading={spinning}
          onClick={() => retrieveTask()}
          style={{ marginLeft: '10px' }}
          type="danger"
          icon="thunderbolt"
        >
          Run Check
        </Button>
        <Checkbox
          checked={showErrorOnly}
          style={{ alignments: 'center', marginLeft: '50px' }}
          // onChange={ onShowError }
          onChange={e => setShowErrorOnly(e.target.checked)}
        >
          Ignore Warnings
        </Checkbox>
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{
            alignment: 'right',
            marginLeft: '10px',
            marginRight: '10px',
            flex: '0 0 200px',
          }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />

        <ExportComponent
          getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
          data={data}
          headers={headerWithFormatter.map(d => ({
            ...d,
            rowHeaderBackgroundColor: '#eee',
          }))}
          fileName={title}
          btnStyle={{ marginRight: '10px' }}
          disabled={data.length <= 0}
        />
      </CriteriaRow>
      <FullHeightSizer heightOffset={300}>
        {({ height, width }) => {
          return data && data.length > 0 ? (
            <Content style={{ height: height - 20 }}>
              <Grid
                ref={GridRef}
                sortEnabled
                isEditable={false}
                data={showErrorOnly ? onlyError : data}
                headers={headerWithFormatter.map(d => ({
                  ...d,
                  rowHeaderBackgroundColor: '#eee',
                }))}
                altBgColor="#ebebeb"
                render={virtualizedGridRenderer({
                  autoFixColByKey: true,
                  rowHeaderRender,
                  height: height - 40,
                  width: width - 50,
                  cellRender,
                  headerRowHeight: 30,
                })}
                fuzzyFilter={fuzzyFilter}
              />
            </Content>
          ) : (
            <Content style={{ height: '200px' }}>
              <Empty
                imageStyle={{ paddingTop: '30px' }}
                description={
                  selectedUnits && selectedUnits.length <= 0
                    ? 'Please select units'
                    : 'Please click on retrieve button to retrieve data'
                }
              />
            </Content>
          )
        }}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(ValidationMonthly)
